<template>
  <v-row>
    <v-col>
      <v-card class="mx-auto">
        <v-card-title
          class="white--text title body-1 pa-2"
          :style="`background-color: ${mainColor}`"
          dense
        >
          <v-icon dens left class="white--text">mdi-remote</v-icon
          >通知設定中一覧
        </v-card-title>
        <v-container
          fluid
          id="scroll-target"
          style="max-height: 200px"
          class="overflow-y-auto py-0"
        >
          <v-row justify="center">
            <v-col cols="12">
              <v-list class="py-0">
                <v-list-item-group :color="mainColor">
                  <v-list-item
                    dense
                    v-for="d in userDevices"
                    :key="d.id"
                    @click="setInfoDeviceId(d.id), $vuetify.goTo(0)"
                  >
                    <v-list-item-icon>
                      <v-icon :color="d.is_alert ? 'error' : 'success'">
                        {{ d.is_alert ? 'mdi-alert' : 'mdi-check-circle' }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="body-2"
                        v-text="d.name"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-btn
                        depressed
                        small
                        dark
                        :color="mainColor"
                        @click.stop="unSet(d)"
                        >解除</v-btn
                      >
                    </v-list-item-icon>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deleteUserDevice } from '@/api'
import { MAIN_COLOR } from '@/constants'

export default {
  name: 'UserDeviceList',
  data() {
    return {
      mainColor: MAIN_COLOR
    }
  },
  computed: {
    ...mapGetters(['userDevices'])
  },
  methods: {
    ...mapActions(['setInfoDeviceId', 'unSetUserDevice']),
    async unSet(device) {
      this.unSetUserDevice(device)
      this.setInfoDeviceId(device.id)
      try {
        await deleteUserDevice(this.$route.params.provider, device.id)
      } catch (e) {
        console.error(e)
        alert('サーバエラーが発生しました。ログイン画面に遷移します。')
        this.$router.push('/auth/sign-out')
        return
      }
    }
  }
}
</script>
